var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharticonsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.5C13.75 1.80964 14.3096 1.25 15 1.25H17.5C18.1904 1.25 18.75 1.80965 18.75 2.5V17.5H19.375C19.7202 17.5 20 17.7798 20 18.125C20 18.4702 19.7202 18.75 19.375 18.75H0.625C0.279822 18.75 0 18.4702 0 18.125C0 17.7798 0.279822 17.5 0.625 17.5H1.25V13.75C1.25 13.0596 1.80964 12.5 2.5 12.5H5C5.69036 12.5 6.25 13.0596 6.25 13.75V17.5H7.5V8.75C7.5 8.05964 8.05964 7.5 8.75 7.5H11.25C11.9404 7.5 12.5 8.05964 12.5 8.75V17.5H13.75V2.5ZM15 17.5H17.5V2.5H15V17.5ZM11.25 17.5V8.75H8.75V17.5H11.25ZM5 17.5V13.75H2.5V17.5H5Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharticonsvg);
export default __webpack_public_path__ + "static/media/charticonsvg.3b51f80f61112d02e6d8bf8cc8fd480d.svg";
export { ForwardRef as ReactComponent };